export const KEYS = {
  POINT_REPOSITORY: Symbol.for('POINT_REPOSITORY'),
  AD_CAMPAIGN_REPOSITORY: Symbol.for('AD_CAMPAIGN_REPOSITORY'),
  STREAM_REPOSITORY: Symbol.for('STREAM_REPOSITORY'),
  BILLING_REPOSITORY: Symbol.for('BILLING_REPOSITORY'),
  BUSINESS_PROFILE_REPOSITORY: Symbol.for('BUSINESS_PROFILE_REPOSITORY'),
};
